import { ViewModel, View, ObservableArray } from "binder"
import { LifeTimeManipulationView } from "./lifeTimeManipulation-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ILifeTime } from "./ILifeTime";
import { ServerConnection } from "src/server/serverConnection";
import { downloadFile, getAsNumber } from "src/uicomponents/components/utilities";
import { FileChooser } from "src/common/utilities";

export class LifeTimeManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'تعریف طول عمر ابزار';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.isLoading = false;
        this.lifeTimes = ObservableArray.create<LifeTime>();
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);

        this.refresh()
    }
    GetDefaultView(): View<ViewModel> {
        return new LifeTimeManipulationView();
    }
    public getTypeId(): string {
        return "VM-E891A530-93C1-404E-A8B5-2599050402CF"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set lifeTimes(v: ObservableArray<LifeTime>) { this._lifeTimes = v; } public get lifeTimes(): ObservableArray<LifeTime> { return this._lifeTimes; } private _lifeTimes: ObservableArray<LifeTime>;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    async refresh() {
        await this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ToolStatusServices/ListOfLifeTimes', {
                FilteringInformation: filteringInformation
            });
            this.lifeTimes.update(...result.LifeTimes.map((x, i) => {
                let l = new LifeTime(this);
                l.index = ((result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageSize) + i + 1;
                l.id = x.Id;
                l.toolTypeName = x.ToolTypeName;
                l.toolModelName = x.ToolModelName;
                l.toolModelFromProducerId = x.ToolModelFromProducerId;
                l.producerName = x.ProducerName;
                l.amount = x.Amount;
                l.additionalLifeTime = x.AdditionalTimeBeforeReplacement;
                l.validStatusId = x.ValidStatusId;
                l.toolStatusName = x.ToolStatusName;
                return l;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async downloadExcel(): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/ToolStatusServices/ExportLifeTimes', {
        });
        downloadFile(result.ExportData, "لیست_طول_عمر_ابزار.xlsx");
        await this.messageBoxConfirmSuccess('دانلود با موفقیت انجام شد.', 'موفق');
    }

    async uploadExcel() {
        try {
            let fileChooser = new FileChooser;
            let choosedFile = await fileChooser.chooseFile();
            if (choosedFile.isChoosed == true) {
                await ServerConnection.callServer('/Complex/ToolStatusServices/UpdateToolStatusLifeTimeFromExcel', {
                    ExcelFile: choosedFile.fileContent
                });
                await this.messageBoxConfirmSuccess('آپلود با موفقیت انجام شد. نتایج در جدول نمایش داده شد.', 'موفق');
                this.dataLoader.refresh();
            }
        } catch (ex) {
            console.log(ex);
        }
    }
}

export class LifeTime extends ViewModel implements ILifeTime {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: LifeTimeManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: LifeTimeManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set toolTypeName(v: string) { this._toolTypeName = v; } public get toolTypeName(): string { return this._toolTypeName; } private _toolTypeName: string;
    public set toolModelName(v: string) { this._toolModelName = v; } public get toolModelName(): string { return this._toolModelName; } private _toolModelName: string;
    public set toolModelFromProducerId(v: string) { this._toolModelFromProducerId = v; } public get toolModelFromProducerId(): string { return this._toolModelFromProducerId; } private _toolModelFromProducerId: string;
    public set producerName(v: string) { this._producerName = v; } public get producerName(): string { return this._producerName; } private _producerName: string;

    public set amount(v: number) {
        this._amount = getAsNumber(v);
    } public get amount(): number { return this._amount; } private _amount: number;

    public set additionalLifeTime(v: number) {
        this._additionalLifeTime = getAsNumber(v);
    } public get additionalLifeTime(): number { return this._additionalLifeTime; } private _additionalLifeTime: number;

    public set validStatusId(v: string) { this._validStatusId = v; } public get validStatusId(): string { return this._validStatusId; } private _validStatusId: string;
    public set toolStatusName(v: string) { this._toolStatusName = v; } public get toolStatusName(): string { return this._toolStatusName; } private _toolStatusName: string;

    async cloneTo(lifeTime: ILifeTime) {
        lifeTime.id = this.id;
        lifeTime.toolTypeName = this.toolTypeName
        lifeTime.toolModelName = this.toolModelName;
        lifeTime.toolModelFromProducerId = this.toolModelFromProducerId;
        lifeTime.producerName = this.producerName;
        lifeTime.amount = this.amount;
        lifeTime.additionalLifeTime = this.additionalLifeTime;
        lifeTime.validStatusId = this.validStatusId;
        lifeTime.toolStatusName = this.toolStatusName;
    }

    async save() {
        try {
            let verificationResult = this.verify();
            if (verificationResult.length > 0) {
                this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت طول عمر ابزار');
                return;
            } else {
                let result = await ServerConnection.callServer("/Complex/ToolStatusServices/UpdateToolStatusLifeTime", {
                    LifeTimeDatas:
                        [{
                            Amount: this.amount,
                            AdditionalTimeBeforeReplacement: this.additionalLifeTime,
                            ToolModelFromProducerId: this.toolModelFromProducerId,
                            ValidStatusId: this.validStatusId
                        }]
                });
                if (result.IsSuccessful == false) {
                    if (result.Faults[0].Parameters.FaultId == '0444EA07-B96F-44B0-9432-47851CEB6078') {
                        await this.messageBoxConfirmWarning('خطایی مربوط به یکی نبودن مدل ابزارها رخ داده است.', 'خطا در عملیات');
                    }
                }
                else {
                    await this.messageBoxConfirmSuccess('طول عمر ابزار با موفقیت ثبت شد.', 'ثبت موفق');
                    this._typedParent.dataLoader.refresh();
                }
            }
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning("خطا در ثبت طول عمر ابزار", "خطا در عملیات");
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (this.amount == 0 && this.additionalLifeTime == 0) {
            result.push('یکی از مقادیر طول عمر و یا مقدار مجاز اضافه کار باید پر شود.');
        }
        return result;
    }
}
